export interface UserPreferences {
  tutorial_add_wallet: boolean;
  tutorial_payment_link: boolean;
  tutorial_completed: boolean;
  china_payments: boolean;
}

export const UserPreferencesKeys = {
  TUTORIAL_ADD_WALLET: 'tutorial_add_wallet',
  TUTORIAL_PAYMENT_LINK: 'tutorial_payment_link',
  TUTORIAL_COMPLETED: 'tutorial_completed',
  CHINA_PAYMENTS: 'china_payments',
} as const;

export interface UseUserPreferencesReturn {
  preferences: UserPreferencesResponse;
  updateOrCreateUserPreference: (
    preference: (typeof UserPreferencesKeys)[keyof typeof UserPreferencesKeys],
    value: string | boolean
  ) => Promise<void>;
}

export type UserPreferencesResponse = {
  created_at: string;
  key: string;
  updated_at: string;
  value: string | boolean;
}[];
